export default __webpack_public_path__ + "static/media/portfolio.2e68c99c.png";